import { connect } from 'react-redux'
import { getIsLogged } from '../../store/login/reducers'
import { canViewMktools } from '../../store/centers/reducers'
import Translation from "../global/Translation";
import React from "react";
import Countdown from "../global/Countdown";
import RectangleResultContainer from '../catalog/rectangleResult/RectangleResultContainer'
import Slider from 'react-slick/lib/slider'
import { getUserLandings } from '../../store/landing/reducers'
import LocalizedLink from '../global/LocalizedLink'
import {fetchProductsLandingsByCenters} from "../../store/landing/actions";
import {getMallProduct} from "../landing-templates/utils";
import ProductContext, {MallProductContext} from "../catalog/rectangleResult/contexts/ProductContext";

const mapStateToProps = state => {
    //const products = getProductsForYou(state)/*getLastProductBoughts(state)*/
    const landingState = state.landing || {}

    return {
        //products: products && products.map(el => el.product),
        hide: !getIsLogged(state) || canViewMktools(state),
        userLandings: getUserLandings(state) || [],
        productsLanding: landingState.productsLanding || [],
        productsLots: landingState.productsLots || {},
        gtmLabel: 'ec_carrusel_promotion_mall'
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchProductsLandingsByCenters: (landingId, centers, products, portfolioMode) => {
            return dispatch(fetchProductsLandingsByCenters(landingId, centers, products, portfolioMode))
        },
    }
}



function SampleNextArrow(props) {
    const { style, onClick } = props
    return (
        <i
            className={'fal fa-chevron-right'}
            style={{ ...style, display: 'block', position: 'absolute', right: '-16px', top: '30%', fontSize: '30px', cursor: 'pointer', zIndex: '10' }}
            onClick={onClick}
        />
    )
}

function SamplePrevArrow(props) {
    const { style, onClick } = props
    return (
        <i
            className={'fal fa-chevron-left'}
            style={{ ...style, display: 'block', position: 'absolute', left: '-14px', top: '30%', fontSize: '30px', cursor: 'pointer', zIndex: '10' }}
            onClick={onClick}
        />
    )
}

class MallPreviewContainer extends React.Component {
    state = {
        slideIndex: 0,
        landings: [],
        lastFetchedLanding: 0,
        slidesToShow: 1
    }

    fetchingLandingIndex = null

    getFormattedMallProduct = (product, productsLanding, productsLots) => {
        try {
            return getMallProduct(product, productsLanding, productsLots)
        } catch (error) {
            return null
        }
    }

    resize = () => {        
        // let slices = 4
        // if(window.innerWidth < 1430) {
        //     slices = 3
        // }
        // if (window.innerWidth < 1010) {
        //     slices = 2
        // }
        // if (window.innerWidth < 768) {
        //     slices = 1
        // }
        const slidesToShow =  this.getSlidesToShow()
        this.setState({ slidesToShow })
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize)
        this.fetchCurrentLanding()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.userLandings !== prevProps.userLandings || this.state.lastFetchedLanding !== prevState.lastFetchedLanding) {
            this.fetchCurrentLanding()
        }

        if (this.props.productsLanding !== prevProps.productsLanding && this.fetchingLandingIndex === this.state.lastFetchedLanding) {
            const userLandings = Array.isArray(this.props.userLandings) ? this.props.userLandings : []
            const productsLanding = Array.isArray(this.props.productsLanding) ? this.props.productsLanding : []
            const productsLots = this.props.productsLots || {}
            const landing = userLandings[this.state.lastFetchedLanding]

            if (landing) {
                const landingProducts = Array.isArray(landing.products) ? landing.products : []
                const products = landingProducts
                    .filter(Boolean)
                    .map(product => this.getFormattedMallProduct(product, productsLanding, productsLots))
                    .filter(Boolean)
                const formattedLanding = { ...landing, products }

                this.fetchingLandingIndex = null
                this.setState(prevState => ({
                    landings: products.length > 0 ? [...prevState.landings, formattedLanding] : prevState.landings,
                    lastFetchedLanding: prevState.lastFetchedLanding + 1
                }), this.resize)
            } else {
                this.fetchingLandingIndex = null
            }
        }
    }

    fetchCurrentLanding = () => {
        const userLandings = Array.isArray(this.props.userLandings) ? this.props.userLandings : []
        const { lastFetchedLanding } = this.state

        if (lastFetchedLanding >= userLandings.length || this.fetchingLandingIndex === lastFetchedLanding) return

        const landing = userLandings[lastFetchedLanding]
        const landingProducts = landing && Array.isArray(landing.products) ? landing.products.filter(Boolean) : []
        const endDate = landing && landing.end_at ? new Date(landing.end_at) : null
        const shouldSkipLanding = !landing
            || landing.common_id == null
            || landingProducts.length === 0
            || !endDate
            || Number.isNaN(endDate.getTime())
            || endDate <= new Date()

        if (shouldSkipLanding) {
            this.setState({ lastFetchedLanding: lastFetchedLanding + 1 })
            return
        }

        this.fetchingLandingIndex = lastFetchedLanding
        this.props.fetchProductsLandingsByCenters(
            landing.common_id,
            Array.isArray(landing.centers) ? landing.centers : [],
            landingProducts,
            landing.portfolio_mode
        )
    }


    getSlidesToShow = () => {
        const maxSlidesToShow = 10
        const minGap = 12
        const minWidth = 250
        const minCardWidth = this.props.minWidth ? this.props.minWidth : minWidth
        const el = document.getElementById('mall-promo-slides')
        if (!el) return 1
        let maxSlides = Math.max(1, Math.floor(el.offsetWidth / minCardWidth)) //250 Card width
        const gap = (el.offsetWidth - minCardWidth * maxSlides) / (1 + maxSlides)
        if (gap < minGap && maxSlides > 1) --maxSlides
        const productsCount = Array.isArray(this.props.productsLanding) ? this.props.productsLanding.filter(Boolean).length : 0
        const slidesCount = productsCount > maxSlides ? maxSlides : productsCount
        return Math.max(1, Math.min(maxSlidesToShow, slidesCount || 1))
    }

    render() {
        const settings = {
            arrows: true,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            swipeToSlide: true,
            dots: true,
            speed: 300,
            slidesToShow: this.state.slidesToShow,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: false
        }
        //if (this.props.hide || !this.props.products || !this.props.products[0]) return <React.Fragment>hola</React.Fragment>
        //console.log({ productNormal: this.props.products[0], productMall: this.props.userLandings[0].products[0]});
        
        return(
            this.state.landings.length > 0 &&(
                this.state.landings.map(landing => {
                    let today = new Date()                    
                    if(new Date(landing.end_at) > today) 
                        return(

                        <section id="section-products-slider" key={landing.common_id || landing.slug}>
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="container" gtm-label={this.props.gtmLabel}>
                                        <div className="general-results-list">
                                            <div className="results-list mall-preview-slider">
                                                <div style={{ padding: '16px 8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="mall-promo-card">
                                                    <h2>
                                                        <span>{landing.title}</span>
                                                    </h2>
                                                    <div className="timer-promo">
                                                        <span><Translation id="time_remaining" defaultMessage="Promotion time remaining" /></span>
                                                        <Countdown endDate={landing.end_at ? landing.end_at : "2025-02-15"} />
                                                    </div>
                                                </div>
                                                <div id="mall-promo-slides" >
                                                    <Slider ref={s => (this.slider = s)} {...settings}>
                                                        {landing.products.map((product, index) => product && (
                                                            <div className="slider-cards" key={`pindex-${index}`}>
                                                                <ProductContext.Provider value={MallProductContext}>
                                                                    <RectangleResultContainer
                                                                        key={index}
                                                                        product={product}
                                                                        mallPromotionSection={true}
                                                                        list='promotion_products'
                                                                        showImg={true}
                                                                    />
                                                                </ProductContext.Provider>
                                                            </div>
                                                        )
                                                        )}
                                                    </Slider>
                                                </div>
                                                <div className={'mall-promotion-container'}>
                                                    <LocalizedLink routeId={"ROUTE_LANDING_TEMPLATE"} params={{ slug: landing ? landing['slug'] : "test", outlet: '', preview: '', iso: '' }} queryString={""} gtmLabel="ec_button_view_promotion_mall">
                                                        <button className={"mall-promotion-btn"}>
                                                            <Translation id="see_products_mall" defaultMessage="See all products of the Mall " />
                                                        </button>
                                                    </LocalizedLink>
                                                </div>
                                            </div>
                                        </div>                               
                                    </div>
                                </div>
                            </div>
                        </div>
                        </section>
                    )
                })
                
            )
        
        )
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MallPreviewContainer)

